var $3a93a0373b3c5cc8$exports = {};
$3a93a0373b3c5cc8$exports = {
    "collectionLabel": `\xd6neriler`
};


export {$3a93a0373b3c5cc8$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
